import { render, staticRenderFns } from "./turncases-approve-pending.vue?vue&type=template&id=9067922c&scoped=true"
import script from "./turncases-approve-pending.vue?vue&type=script&lang=ts"
export * from "./turncases-approve-pending.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9067922c",
  null
  
)

export default component.exports